import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HomeComponent } from '../../home/home.component';
import { menuOptions } from 'src/data/menu-options.data';

@Component({
    selector: 'spe-historico-de-ocorrencias',
    templateUrl: './historico-de-ocorrencias.component.html',
    styleUrls: ['./historico-de-ocorrencias.component.scss'],
    standalone: false
})
export class HistoricoDeOcorrenciasComponent implements OnInit {
  iFrameUrl: string = environment.urlOcorrecias + '/operacoesOcorrencia/selecionarOcorrencia.xhtml';

  idCliente: string = localStorage.getItem('idCliente') ?? '';
  idParceria: string = localStorage.getItem('idParceria') ?? '';
  idUsuario: string = '163';
  idNegocioSistema = 2;

  /* params = ?idUsuario=163&amp;idNegocioSistema=2&amp;idCliente=10586953&amp;tpOperacao=historico&amp;idGerenciamentoOcorrencia=1&amp;idParceria= */

  constructor(private homeComponent: HomeComponent) {}

  ngOnInit(): void {
    this.homeComponent.setNewVariables(
      'Histórico de ocorrências',
      'Verifique abaixo o histórico de ocorrências.',
      `ocorrencias`
    );
    this.homeComponent.idleMenuContent = menuOptions[4].content;
    this.homeComponent.iconPath = 'assets/images/64_icon_id_cards.png';
    this.makeUrl();
  }

  makeUrl() {
    let params: string = `?idUsuario=${this.idUsuario}&idNegocioSistema=${this.idNegocioSistema}&idCliente=${this.idCliente}&idGerenciamentoOcorrencia=1&tpOperacao=historico&idParceria=${this.idParceria}`;
    this.iFrameUrl = this.iFrameUrl + params;
  }
}
